import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="py-32 text-center text-stone-500 font-serif text-xl" data-testid="auth-loading">
                Checking credentials...
            </div>
        );
    }

    if (!user) return <Navigate to="/admin/login" replace />;

    return children;
};

export default ProtectedRoute;
